package net.frozenbit.games.soundgame.viewmodels.deeplink

import io.ktor.http.*
import kotlinx.browser.window

fun joinLink(code: String): String {
    return URLBuilder(urlString = window.location.href).apply {
        // The server will redirect to /?c=code
        appendPathSegments("G", code)
    }.buildString()
}

fun joinCodeFromUrl(): String? {
    val url = URLBuilder(urlString = window.location.href)
    return url.parameters["c"]
}
